export const BILLING_ENTITY_OPTIONS = ["UK", "UAE"];

export const normalizeBillingEntity = (company) => {
  const normalized =
    typeof company === "string" ? company.trim().toUpperCase() : "";

  if (normalized === "UK") return "UK";
  if (normalized === "UAE") return "UAE";
  return "Unassigned";
};

export const isSupportedBillingEntity = (company) =>
  BILLING_ENTITY_OPTIONS.includes(company);

export const getAllowedBillingEntitiesForProjects = (projects = []) => {
  let allowedCompanies = [...BILLING_ENTITY_OPTIONS];

  (Array.isArray(projects) ? projects : []).forEach((project) => {
    const company = normalizeBillingEntity(project?.company);
    if (company === "Unassigned") return;
    allowedCompanies = allowedCompanies.filter((option) => option === company);
  });

  return allowedCompanies;
};

export const resolveBillingEntitySelection = (
  projects = [],
  preferredCompany = "UK"
) => {
  const allowedCompanies = getAllowedBillingEntitiesForProjects(projects);
  if (!allowedCompanies.length) return null;
  return allowedCompanies.includes(preferredCompany)
    ? preferredCompany
    : allowedCompanies[0];
};
